import React from 'react';
import style from '../App/App.module.scss';
import classnames from 'classnames';
import { sportsDict } from '../../constants';
import swiperAnimation from '../../assets/images/animation.gif';
import { useSports } from '../../hooks/useSports.hook';
import { IOneTimePaymentItem, IPlan } from '../../model';

interface IProps {
  plans: IPlan[];
  yearly: boolean;
  setYearly?: (yearly: boolean) => void;
  onePaymentItems: IOneTimePaymentItem[];
  selectedSport: string;
  setSelectedSport: (sport: string) => void;
}

const Toolbar: React.FC<IProps> = ({
                                     plans,
                                     yearly,
                                     setYearly,
                                     onePaymentItems,
                                     selectedSport,
                                     setSelectedSport
                                   }) => {
  // const maxPlan = plans.filter(plan => plan.plan_tier === 4 && plan.display.sport_category === 'all')?.[0];
  // const maxPlanSplitPrice = (maxPlan?.prices?.yearly?.unit_amount / 100 / 12).toFixed(2).split('.');
  const sports = useSports(plans, onePaymentItems, setSelectedSport, selectedSport);
  return (
    <div className={style.header}>
      <div className={style.left}>
        <h1 className={style.title}>Get the Edge you need</h1>
      </div>
      <div
        className={classnames(style.sport_switch_wrapper)}>
        <div className={classnames('tab-primary sport-switch', style.sport_switch)}>
          {sports.map(sport => {
            const badgeText = window.tabsBadges?.[sport];

            return (<label className={style.sport_switch_input} key={sport + (selectedSport === sport ? '_active' : '')}>
              <input type="radio" name="sport" value={sport} checked={selectedSport === sport} onChange={(e) => {
                setSelectedSport(e.target.value);
              }}/>
              <div className={classnames('tab-primary__item', style.sport_switch_item)}>
                {sportsDict[sport] || sport}
              </div>
              {badgeText ? <div className={style.badge}>{badgeText}</div> : ''}
            </label>);
          })}
        </div>
      </div>
      <div className={classnames(style.switch, {[style.disabled]: !setYearly})}>
        <label className={style.switch_wrapper}>
          <input type="checkbox" name="price-period" value="Yearly" checked={yearly}/>
          <span className={style.switch_option} onClick={() => setYearly?.(false)}>Monthly</span>
          <span className={style.switch_toggle} onClick={() => {
            setYearly?.(!yearly)
          }}></span>
          <span className={style.switch_option} onClick={() => setYearly?.(true)}>
              Annually
              <span className={style.badge}>save up to 50%</span>
            </span>
        </label>
      </div>
      <div className={classnames(style.scroll_sentence)}>
          <span className={classnames(style.scroll_sentence_text)}>
            Swipe
            <span className={classnames(style.scroll_sentence_sticker)}>
              <img src={swiperAnimation} alt={'swipe'}/>
            </span>
            for more options
          </span>
      </div>
    </div>
  );
};

export default Toolbar;
